import { makeDataForNonCollapseTable } from 'src/components/collapsible-table/table-data-prep';
import { CHECKBOX_VALUES } from '../pricing-simulator/types/generic-table.model';

// eslint-disable-next-line import/prefer-default-export
export const getFilteredRows = (
  rowData: any,
  searchInputVal: string,
  activeCheckboxValues: CHECKBOX_VALUES[]
) =>
  makeDataForNonCollapseTable(rowData)
    /** Updating the value for rows as per the selection
        of the checkbox that is present in the top bar 
    */

    .filter((row) =>
      activeCheckboxValues.some((data) => {
        switch (data) {
          case CHECKBOX_VALUES.IS_ACTIVE_FINALIZED:
            return row.is_active || row.is_finalized;

          case CHECKBOX_VALUES.IS_FINALIZED:
            return row.is_finalized;

          case CHECKBOX_VALUES.IS_ARCHIVED:
            return row.is_archived;

          default:
            return [];
        }
      })
    )
    .filter((row) => {
      if (searchInputVal.trim()) {
        return (
          (row.name || '')
            .toLowerCase()
            .includes(searchInputVal.toLowerCase()) ||
          row.category.toLowerCase().includes(searchInputVal.toLowerCase()) ||
          row.channel.toLowerCase().includes(searchInputVal.toLowerCase()) ||
          row.retailer.toLowerCase().includes(searchInputVal.toLowerCase()) ||
          row.cell.toLowerCase().includes(searchInputVal.toLowerCase()) ||
          row.author.toLowerCase().includes(searchInputVal.toLowerCase())
        );
      }
      return true;
    });
